import React from 'react'

import { Route } from 'react-router'

import PayrollDetails from './PayrollDetails'
import Payrolls from './Payrolls'
import PipMsgTypes from './PipMsgTypes'
import PowerGrids from './PowerGrids'
import SuperAdminLayout from './SuperAdminLayout'

function SuperAdminRoutes(props) {
  return (
    <SuperAdminLayout>
      <Route path="/internal/super_admin/payroll/details" component={() => <PayrollDetails />} />
      <Route path="/internal/super_admin/payroll" exact component={() => <Payrolls />} />
      <Route path="/internal/super_admin/powerGrids" component={() => <PowerGrids />} />
      <Route path="/internal/super_admin/pipMsgTypes" component={() => <PipMsgTypes />} />
    </SuperAdminLayout>
  )
}

export default SuperAdminRoutes
